'use client'

import { useEffect } from 'react'

/** SVG path data for the 500 robot — mirrors components/error/images/error-500.tsx */
const error500Path =
  'M138.536 42.8376C138.536 35.574 132.637 29.6748 125.373 29.6748C118.11 29.6748 112.211 35.574 112.211 42.8376C112.211 50.1012 118.11 56.0004 125.373 56.0004C132.637 56.0004 138.536 50.0611 138.536 42.8376ZM119.715 42.8376C119.715 39.7074 122.243 37.1792 125.373 37.1792C128.504 37.1792 131.032 39.7074 131.032 42.8376C131.032 45.9678 128.504 48.496 125.373 48.496C122.243 48.496 119.715 45.9276 119.715 42.8376ZM178.667 56.0004C185.93 56.0004 191.829 50.1012 191.829 42.8376C191.829 35.574 185.93 29.6748 178.667 29.6748C171.403 29.6748 165.504 35.574 165.504 42.8376C165.504 50.1012 171.403 56.0004 178.667 56.0004ZM178.667 37.1792C181.797 37.1792 184.325 39.7074 184.325 42.8376C184.325 45.9678 181.797 48.496 178.667 48.496C175.536 48.496 173.008 45.9678 173.008 42.8376C173.008 39.7074 175.577 37.1792 178.667 37.1792ZM134.162 77.4701H169.918V73.6979C169.918 63.8258 161.892 55.8398 152.06 55.8398C142.228 55.8398 134.202 63.8659 134.202 73.6979V77.4701H134.162ZM152.02 63.3844C156.394 63.3844 160.166 66.1132 161.651 69.9658H142.389C143.874 66.1132 147.646 63.3844 152.02 63.3844ZM241.712 85.4962C241.712 104.157 226.542 119.366 207.841 119.366H198.411V118.724C198.411 110.016 191.308 102.913 182.599 102.913H182.399V93.9638H186.291C194.037 93.9638 200.578 88.4258 201.862 80.801L210.49 29.6748C211.373 24.5381 209.768 19.3613 206.276 15.8298C204.069 13.6226 201.34 12.178 198.371 11.5359V4.27226C198.371 2.18548 196.685 0.5 194.598 0.5C192.512 0.5 190.826 2.18548 190.826 4.27226V11.1747H113.134V4.27226C113.134 2.18548 111.448 0.5 109.361 0.5C107.275 0.5 105.589 2.18548 105.589 4.27226V11.5359C102.619 12.178 99.8906 13.6226 97.6834 15.8298C94.152 19.3613 92.5869 24.5381 93.4296 29.6748L102.058 80.801C103.342 88.4258 109.883 93.9638 117.628 93.9638H121.28V102.913C112.612 102.953 105.549 110.016 105.549 118.724V119.366H96.1183C77.4577 119.366 62.2483 104.197 62.2483 85.4962V63.585H54.7038V85.4962C54.7038 108.33 73.2841 126.871 96.0782 126.871H105.509V160.5H113.053V148.461H190.826V160.5H198.371V126.871H207.801C230.636 126.871 249.176 108.29 249.176 85.4962V63.585H241.631V85.4962H241.712ZM195.16 18.7192C197.367 18.7192 199.454 19.562 201.019 21.127C202.825 22.9329 203.628 25.6216 203.146 28.3906L194.518 79.5168C193.836 83.5298 190.425 86.4192 186.372 86.4192H117.668C113.615 86.4192 110.164 83.5298 109.522 79.5168L100.894 28.3906C100.412 25.6618 101.215 22.9329 103.021 21.127C104.586 19.562 106.673 18.7192 108.88 18.7192H195.16ZM128.865 93.9638H174.934V102.913H128.865V93.9638ZM182.64 110.417C187.214 110.417 190.906 114.149 190.906 118.684V140.916H113.134V118.684C113.134 114.109 116.866 110.417 121.401 110.417H182.64ZM261.817 38.5035H258.125C256.439 31.4406 250.059 26.1433 242.474 26.1433H239.866C239.585 24.3375 238.02 22.9329 236.133 22.9329H224.455C222.369 22.9329 220.683 24.6184 220.683 26.7052V57.8062C220.683 59.893 222.369 61.5785 224.455 61.5785H236.093C237.979 61.5785 239.544 60.1739 239.825 58.3681H242.434C250.019 58.3681 256.359 53.111 258.085 46.0079H261.777C280.437 46.0079 295.647 61.1772 295.647 79.878V160.5H303.191V79.878C303.191 57.0438 284.611 38.5035 261.817 38.5035ZM242.474 50.8235H239.906V38.4232H232.361V54.034H228.268V30.4774H232.401V33.6879H242.474C247.209 33.6879 251.062 37.5404 251.062 42.2758C251.062 47.0112 247.209 50.8235 242.474 50.8235ZM73.7657 54.5958V52.8702H80.6681V45.3257H73.7657V38.9851H80.6681V31.4406H73.7657V29.8755C73.7657 27.7887 72.0802 26.1032 69.9934 26.1032H53.0183C45.3132 26.1032 38.8924 31.5208 37.2871 38.7443C16.7805 41.1922 0.808594 58.6891 0.808594 79.8378V160.46H8.35311V79.878C8.35311 62.8225 21.0343 48.6565 37.4477 46.3691C39.2535 53.2715 45.554 58.3681 53.0183 58.3681H69.9934C72.0802 58.3681 73.7657 56.6826 73.7657 54.5958ZM44.4705 42.2356C44.4705 37.5002 48.323 33.6477 53.0584 33.6477H66.2613V50.8235H61.8068V38.4232H54.2623V50.8235H53.0584C48.323 50.8235 44.4705 46.971 44.4705 42.2356ZM184.004 119.166V126.71H120.036V119.166H184.004Z'

/**
 * Root-level error boundary that catches errors in the root layout itself.
 *
 * Unlike `error.tsx` (which catches errors in route segments), this is the
 * only boundary that can catch errors from `app/layout.tsx` — e.g. auth
 * provider failures, context provider errors, or font loading issues.
 *
 * Because the root layout's providers (theme, i18n, router) are unavailable
 * here, we reproduce the 500 error page styling with inline styles and
 * hardcoded copy instead of using the shared `ErrorLayout` component.
 */
export default function GlobalError({
  error,
  _reset,
}: {
  error: Error & { digest?: string }
  // Reset is intentionally unused — after a root layout crash the provider
  // tree is gone, so re-rendering the same layout is unlikely to recover.
  // We link to /dashboard instead of calling reset().
  _reset: () => void
}) {
  useEffect(() => {
    // biome-ignore lint/suspicious/noConsole: Intentional — log the root layout error for the logging provider.
    console.error(
      `GlobalError [digest:${error.digest ?? 'none'}] ${error.message}`,
      error
    )
  }, [error])

  return (
    <html lang="en">
      <head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap"
          rel="stylesheet"
        />
      </head>
      <body
        style={{
          margin: 0,
          padding: 0,
          fontFamily:
            'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          backgroundColor: '#111e28',
          backgroundImage:
            'url("https://res.cloudinary.com/magicsky/image/upload/v1759171042/cdn/images/bg-qfmp.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          color: 'rgba(255, 255, 255, 0.9)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '2.5rem',
            width: '100%',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="304"
            height="161"
            viewBox="0 0 304 161"
            style={{ fill: '#3eea9c', maxWidth: '304px', maxHeight: '161px' }}
          >
            <path d={error500Path} />
          </svg>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span
              style={{
                fontSize: '6.25rem',
                fontWeight: 800,
                lineHeight: 1,
                marginBottom: '0.25rem',
              }}
            >
              500
            </span>
            <span
              style={{
                fontSize: '1.875rem',
                fontWeight: 600,
                color: '#3eea9c',
                marginBottom: '0.25rem',
              }}
            >
              Internal Server Error
            </span>
            <span style={{ color: 'rgba(255, 255, 255, 0.4)' }}>
              It&apos;s not you. It&apos;s me.
            </span>
          </div>

          <a
            href="/dashboard"
            style={{
              display: 'inline-block',
              padding: '0.625rem 1.25rem',
              fontSize: '0.875rem',
              fontWeight: 500,
              fontFamily: 'inherit',
              borderRadius: '0.5rem',
              border: 'none',
              background: 'linear-gradient(135deg, #3eea9c 0%, #2dd88a 100%)',
              color: '#0a0a0a',
              cursor: 'pointer',
              textDecoration: 'none',
              transition: 'opacity 0.15s',
            }}
          >
            Take Me Home
          </a>
        </div>
      </body>
    </html>
  )
}
